"use strict";
export const PaymentCalculateMock = (mock) => {
  mock.onPost("/api/v7/payment/calculate/create").reply((config) => {
    let response = {
      "msg": null,
      "original_cost": 69,
      "cost": 69,
      "max_coin": 69,
      "discount_coupon_used": null,
      "model": "payment.virtualdesktop.calculate.new.calc_result",
      "vdcard_used": null,
      "coin_left": 991.6
    };
    return [200, response];
  });
};
